import { CommonModule } from "@angular/common";
import { SectionSearchHeaderModule } from "../app/section-search-header/section-search-header.module";
import * as i0 from "@angular/core";
export class CompatSectionSearchHeaderModule {
}
CompatSectionSearchHeaderModule.ɵfac = function CompatSectionSearchHeaderModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSectionSearchHeaderModule)(); };
CompatSectionSearchHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompatSectionSearchHeaderModule });
CompatSectionSearchHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [SectionSearchHeaderModule, CommonModule] });
